module.exports = __webpack_public_path__ + "static/media/port.909a4fba.webp";